import Footer from "../components/footer";
import "../components/partner-referrals/partner-referrals.css";
import { useNavigate,useLocation } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { paths } from "../paths";
import PartnerReferralList from "../components/partner-referrals/referral-list";
import MainLayout from "../layouts/main-layout";

function PartnerReferrals() {
  const navigate = useNavigate();
  const location = useLocation();
  const filterBy = location.state?.filterBy || 'All';

  return (
    <MainLayout>
      <h1 className="pageHeading">
        My Referrals
      </h1>
      <Breadcrumbs className="breadCrumbs" aria-label="breadcrumb">
        <Link color="inherit" onClick={() => navigate(paths.partner.dashboard.overview)} sx={{ cursor: 'pointer' }}>
          Home
        </Link>
        <Typography color="inherit">Referrals</Typography>
      </Breadcrumbs>
    
      <div className="partnerReferrals">
    
        <div className="row">
          <div className="col-md-12">
            <PartnerReferralList initialFilter={filterBy} />
          </div> 
        </div>
     
      </div>
    </MainLayout>
  );
}

export default PartnerReferrals;